import { Endpoint, SSOService } from '@philips-emr/hpms-provider-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { UserConfirmAliases as Aliases, FragmentNames } from '../../codegen';
import { FOUNDATION_ROUTES } from '../../route';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.USER_CONFIRM })
export default class UserConfirmController extends BaseController {
  @OnMount(Aliases.PANEL_CONF_USER)
  onMountConfUsuario(): void {
    SSOService.ssoEnabled();
    const { hash } = this.historyService.getCurrentRouteParams();
    HttpService.get(Endpoint.GET.VALIDATE_HASH_USER_CONFIRM, { hash })
      .then(() => this.historyService.push(FOUNDATION_ROUTES.CONFIRM_USER_NEW_PW, { hash }))
      .catch(() => this.historyService.push(FOUNDATION_ROUTES.CONFIRM_USER_FAIL));
  }
}
